import { useEffect, useRef } from 'react';
import { normalizeFps } from '../utils/timecodeFormatter';
/**
 * Polls `mediaEl.currentTime` via `requestAnimationFrame` during playback and
 * dispatches `TIME_UPDATE` every time the video frame changes.  This gives
 * smooth, frame-accurate timecode display instead of the browser's ~250ms
 * `timeupdate` event cadence.
 */
export function useFrameAccurateTime(mediaEl, isPlaying, fps, dispatch) {
    const lastFrameRef = useRef(-1);
    useEffect(() => {
        if (!mediaEl || !isPlaying) {
            lastFrameRef.current = -1;
            return;
        }
        let animId;
        // Use the exact NTSC rational rate so frame detection here matches
        // the frame index that formatTimecode displays — otherwise at long
        // durations a 29.97-vs-30000/1001 mismatch flips Math.floor by one
        // and the dispatch fires for a frame the display has already moved
        // past (or vice versa).
        const effectiveFps = normalizeFps(fps || 30);
        const tick = () => {
            const time = mediaEl.currentTime;
            const frame = Math.floor(time * effectiveFps);
            if (frame !== lastFrameRef.current) {
                lastFrameRef.current = frame;
                dispatch({ type: 'TIME_UPDATE', currentTime: time });
            }
            animId = requestAnimationFrame(tick);
        };
        animId = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(animId);
    }, [mediaEl, isPlaying, fps, dispatch]);
}
